<script>
import _ from 'lodash'
import { saveAs } from 'file-saver';
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { portsActions, usersActions } from '@state/helpers'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Master Port',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'Master Port',
      port_types: [
        { value: 'DOCKING', text: 'Docking' },
        { value: 'LOADING_PORT', text: 'Loading Port' },
        { value: 'DISCHARGING_PORT', text: 'Discharging Port' },
      ],
      ports: [],
      users: [],
      loading: true,
      loading_form: false,
      loading_delete: false,
      loading_export: false,
      edit_mode: false,
      params: {
        name: '',
        active: true
      },
      form: {
        portName: '',
        portType: '',
        user: []
      },
      edit_port_id: '',
    }
  },
  created() {
    this.fetchPorts = _.debounce(this.fetchPorts, 2000)
  },
  mounted() {
    this.fetchPorts()
    this.fetchUsers()
  },
  methods: {
    ...portsActions,
    ...usersActions,
    async fetchPorts() {
      this.loading = true
      let params = this.$options.filters.cleanObject(this.params)
      let res = await this.getPorts(params)
      this.ports = res.data
      this.loading = false
    },
    async fetchUsers() {
      let params = {
        page: 1,
        active: true
      }
      let res = await this.getUsers(params)
      this.users = res.data
    },
    async onSubmit() {
      let form_has_empty_value = false;
      for(var key in this.form) {
        if(this.form[key] === "") form_has_empty_value = true;
        else if (Array.isArray(this.form[key]) && !this.form[key].length) form_has_empty_value = true;
      }

      if (form_has_empty_value) this.$swal("Empty form!", "Please check again and fill all the forms.", "error");
      else {
        this.loading_form = true

        let data = {
          portName: this.form.portName,
          portType: this.form.portType,
          user: []
        }
        if (Array.isArray(this.form.user))
          this.form.user.forEach(user => data.user.push({ id: user }))
        else data.user = [ { id: this.form.user } ]

        if (!this.edit_mode) {
          let res = await this.savePort(data)
          if (res.status == 'success') {
            this.loading_form = false
            this.$swal(
              'Port added!',
              'Port added successfully.',
              'success'
            )
            this.fetchPorts()
            this.onCancel()
          } else {
            this.loading_form = false
            if (res.data.message != null)
              this.$swal('Error', res.data.message, 'error')
            else
              this.$swal(
                'Error',
                'Something wrong with the server. Please try again later.',
                'error'
              )
          }
        } else {
          let res = await this.updatePort({ id: this.edit_port_id, data })
          if (res.status == 'success') {
            this.loading_form = false
            this.$swal(
              'Port updated!',
              'Port updated successfully.',
              'success'
            )
            this.fetchPorts()
            this.onCancel()
          } else {
            this.loading_form = false
            if (res.data.message != null)
              this.$swal('Error', res.data.message, 'error')
            else
              this.$swal(
                'Error',
                'Something wrong with the server. Please try again later.',
                'error'
              )
          }
        }
      }
    },
    async doExport() {
      this.loading_export = true
      let res = await this.exportPort()
      if (res.status == 'success') {
        this.loading_export = false
        saveAs(res.data, "Port List.xlsx");
      } else {
        this.loading_export = false
        if (res.data.message != null)
          this.$swal('Error', res.data.message, 'error')
        else
          this.$swal(
            'Error',
            'Something wrong with the server. Please try again later.',
            'error'
          )
      }
    },
    onEdit(port) {
      this.edit_mode = true
      this.edit_port_id = port.id
      this.form.portName = port.portName
      this.form.portType = port.portType
      this.form.user = []
      port.user.forEach(user => this.form.user = user.id )
    },
    onCancel() {
      this.edit_mode = false
      this.form = {
        portName: '',
        portType: '',
        user: []
      }
    },
    onDeletePort(port) {
      this.$swal({
        title: 'Delete port?',
        text: `Port ${port.portName} will be deleted and cannot be recovered.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading_delete = true
          let res = await this.deletePort(port.id)
          if (res.status != 'success') {
            this.loading_delete = false
            if (res.data.message != null)
              this.$swal('Error', res.data.message, 'error')
            else
              this.$swal(
                'Error',
                'Something wrong with the server. Cannot get user data.',
                'error'
              )
          } else {
            this.loading_delete = false
            this.fetchPorts()
            this.$swal(
              `Role deleted!`,
              `Role ${port.portName} successfully deleted`,
              'success'
            )
          }
        }
      })
    },
    menuObject(output) {
      const { menuObject } = this.$route.query
      return JSON.parse(window.atob(menuObject))[output]
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <!-- Content Section -->
    <b-row>
      <b-col :lg="!menuObject('add') || !menuObject('update') ? 12 : 8">
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col cols="4">
                <b-form-input
                  id="fleet_name"
                  type="text"
                  placeholder="Search Ports..."
                  v-model="params.name"
                  @input="fetchPorts"
                ></b-form-input>
              </b-col>
              <b-col cols="6"> </b-col>
              <b-col cols="2"
                v-if="menuObject('export')">
                <b-button block variant="primary" @click="doExport">
                  <template v-if="!loading_export">
                    <i class="fa fa-file-excel"></i> &nbsp; Export Excel
                  </template>
                  <template v-else>
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Exporting...
                  </template>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>

        <b-card>
          <b-card-title>
            <h4 class="card-title font-size-16">Port List</h4>
          </b-card-title>
          <b-card-body>
            <div v-if="loading" class="text-center my-5">
              <b-spinner type="grow" label="Spinning"></b-spinner>
            </div>
            <template v-else>
              <div class="table-responsive" v-if="ports.length > 0">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th width="5%" class="text-center">No</th>
                      <th width="25%">Port Name</th>
                      <th width="15%">Type</th>
                      <th width="35%">PIC</th>
                      <th width="20%">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(port, i) in ports" :key="`port-${i}`">
                      <td class="text-center">{{ i+1 }}</td>
                      <td>{{ port.portName }}</td>
                      <td>{{ port.portType }}</td>
                      <td>
                        <ul class="m-0 pl-3">
                          <li v-for="(user, is) in port.user" :key="`user-${is}`"
                            style="list-style-type: circle">{{ user.name }}</li>
                        </ul>
                      </td>
                      <td>
                        <b-button variant="success" size="sm" class="mr-2"
                          v-if="menuObject('update')"
                          @click="onEdit(port)"
                          ><i class="fa fa-edit"></i></b-button
                        >
                        <b-button variant="danger" size="sm" @click="onDeletePort(port)"
                          v-if="menuObject('delete')">
                          <i v-if="!loading_delete" class="fa fa-trash"></i>
                          <template v-else>
                            <span
                              class="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Deleting...
                          </template>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p v-else class="text-center my-4">No ports data found.</p>
            </template>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col lg="4" v-if="menuObject('add') || menuObject('update')">
        <div class="card" :class="{ 'border border-danger shadow-lg': edit_mode }">
          <div class="card-body">
            <h3 class="mb-4 header-title">{{ edit_mode ? 'Edit' : 'Add' }} Port</h3>
            <b-form>
              <b-form-group label="Port Name" label-for="port_name">
                <b-form-input
                  id="port_name"
                  type="text"
                  placeholder="Port Name"
                  v-model="form.portName"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Type Port" label-for="type_port">
                <v-select
                  v-model="form.portType"
                  :getOptionLabel="(type) => type.text"
                  :options="port_types"
                  :reduce="type => type.value"
                  placeholder="Select Type"
                ></v-select>
              </b-form-group>

              <b-form-group label="PIC" label-for="user">
                <v-select
                  v-model="form.user"
                  multiple
                  :getOptionLabel="(user) => user.userDetail.name"
                  :options="users"
                  :reduce="user => user.id"
                  placeholder="Select PIC"
                ></v-select>
              </b-form-group>

              <b-form-group class="text-right">
                <b-button type="button" variant="primary" @click="onSubmit">
                  <template v-if="!loading_form">
                    {{ edit_mode || !menuObject('add') ? 'Save' : 'Add' }}
                  </template>
                  <template v-else>
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </template>
                </b-button>
                <b-button
                  type="button"
                  variant="danger"
                  class="iq-bg-danger ml-2"
                  @click="onCancel"
                  >Cancel</b-button
                >
              </b-form-group>
            </b-form>
          </div>
        </div>
      </b-col>
    </b-row>
  </Layout>
</template>
